import { useState } from 'react';
import { useChatStore } from '../../store/chatStore';
import { ChatHeader } from '../chat/ChatHeader';
import { MessageList } from '../chat/MessageList';
import { MessageInput } from '../chat/MessageInput';
import { WelcomeScreen } from '../chat/WelcomeScreen';
import { GuardrailsTestPanel } from '../chat/GuardrailsTestPanel';

/**
 * Main layout wrapper that composes the chat header, message list (or welcome screen),
 * guardrails test panel, and message input into the primary chat interface.
 */
export function ChatLayout() {
  const { messages } = useChatStore();
  const hasMessages = messages.length > 0;
  const [guardrailsTestMode, setGuardrailsTestMode] = useState(false);

  return (
    <div className="flex-1 flex flex-col h-full bg-white">
      <ChatHeader
        guardrailsTestMode={guardrailsTestMode}
        onToggleGuardrailsTest={() => setGuardrailsTestMode((v) => !v)}
      />

      <div className="flex-1 overflow-hidden">
        {hasMessages ? <MessageList /> : <WelcomeScreen />}
      </div>

      {guardrailsTestMode && <GuardrailsTestPanel />}
      <MessageInput />
    </div>
  );
}
